import { render, staticRenderFns } from "./ArticleAddOrEdit.vue?vue&type=template&id=71b7da37&scoped=true&"
import script from "./ArticleAddOrEdit.vue?vue&type=script&lang=js&"
export * from "./ArticleAddOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b7da37",
  null
  
)

export default component.exports